import {IDocumentoNoExigible} from '../models/documentosObligatorios/idocumentosObligatorios';
import {Documents} from '../models/request/documents';

export class DocumentosDigitalesManager {
  private static documentosMotivoSolicitud: any;
  private static contentDocuments: Documents[] = [];
  private static indexMotivoSolicitudJson: number;
  private static soporteDigitalRNEC: File;

  public static getDocumentosMotivoSolicitud() {
    return this.documentosMotivoSolicitud;
  }

  public static getIndexMotivoSolicitud() {
    return this.indexMotivoSolicitudJson;
  }

  public static setDocumentosSolicitud(
    documentosDeSolicitud: any,
  ) {
    this.contentDocuments = [];
    this.documentosMotivoSolicitud =
      documentosDeSolicitud;
  }

  /**
   public static retirarDocumentosNoExigiblesJeffrey(
   documentosPropietarioEncontrados: IDocumentoNoExigible[],
   tipoIdentidadTitular: string,
   numIdentificacionTitular: string,
   tipoIdentidadBeneficiario: string,
   numIdentificacionBeneficiario: string,
   ) {

   const documentosObligatorios = this.documentosMotivoSolicitud.reason
   .filter((documentoSolicitud) => {
   const documento: Documents = this.mapearAContentDocument(
   documentoSolicitud,
   documentosPropietarioEncontrados,
   tipoIdentidadTitular,
   numIdentificacionTitular,
   tipoIdentidadBeneficiario,
   numIdentificacionBeneficiario
   );
   return !documento.digitalSupport;
   })
   .map(doc => ({
   ...doc,
   required: true
   }));

   let documentosEliminados = this.documentosMotivoSolicitud
   .filter((documentoSolicitud) => !documentosObligatorios.some(o => o.idTipoDocumento === documentoSolicitud.idTipoDocumento))
   .map(docEliminado => {
   const encontrado = documentosPropietarioEncontrados.find(dp =>
   dp.idTipoDocumento === docEliminado.idTipoDocumento
   );

   const docConNombre = encontrado
   ? {...docEliminado, nombre: encontrado.nombre}
   : docEliminado;

   return {
   ...docConNombre,
   required: false
   };
   });

   return {documentosObligatorios, documentosEliminados};
   }
   **/

  public static retirarDocumentosNoExigibles(
    documentosPropietarioEncontrados: IDocumentoNoExigible[],
    tipoIdentidadTitular: string,
    numIdentificacionTitular: string,
    tipoIdentidadBeneficiario: string,
    numIdentificacionBeneficiario: string,
  ) {
    const documentosObligatorios = this.documentosMotivoSolicitud
      .filter((documentoSolicitud) => {
        const documento: Documents = this.mapearAContentDocument(
          documentoSolicitud,
          documentosPropietarioEncontrados,
          tipoIdentidadTitular,
          numIdentificacionTitular,
          tipoIdentidadBeneficiario,
          numIdentificacionBeneficiario
        );
        return !documento.digitalSupport;
      })
      .map(doc => ({
        ...doc,
        required: true
      }));

    const documentosEliminados = documentosPropietarioEncontrados
      .filter(docEncontrado => {
        return !documentosObligatorios.some(ob =>
          ob.idTipoDocumento === docEncontrado.idTipoDocumento &&
          ob.propietario === docEncontrado.propietario
        );
      })
      .map(docEliminado => {
        const solicitudOriginal = this.documentosMotivoSolicitud.find(ds =>
          ds.idTipoDocumento === docEliminado.idTipoDocumento &&
          ds.propietario === docEliminado.propietario
        );

        console.log('solicitudOriginal:', solicitudOriginal);

        return {
          ...docEliminado,
          required: false,
          idForm: solicitudOriginal?.idForm ?? null,
          label: solicitudOriginal?.label ?? '',
        };
      });

    return {documentosObligatorios, documentosEliminados};
  }

  private static mapearAContentDocument(
    documentoSolicitud: any,
    documentosEncontrados: IDocumentoNoExigible[],
    tipoIdentidadTitular: string,
    numIdentificacionTitular: string,
    tipoIdentidadBeneficiario: string,
    numIdentificacionBeneficiario: string
  ) {

    const documentoEncontradoPorId = documentosEncontrados.find(
      (documentoEncontrado) => {
        const esIdTipoDocumento =
          documentoEncontrado.idTipoDocumento ==
          documentoSolicitud.idTipoDocumento;
        const esPropietario =
          documentoEncontrado.propietario == documentoSolicitud.propietario;
        return esIdTipoDocumento && esPropietario;
      }
    );
    const esDocumentoDigitalnoExigible = !!documentoEncontradoPorId;
    const propietarioEsTitular = documentoSolicitud.propietario == 'T';
    const tipoIdentificacionPropietario = propietarioEsTitular
      ? tipoIdentidadTitular
      : tipoIdentidadBeneficiario;
    const numIdentificacionPropietario = propietarioEsTitular
      ? numIdentificacionTitular
      : numIdentificacionBeneficiario;
    let document = new Documents(
      documentoSolicitud.id,
      documentoSolicitud.label,
      !esDocumentoDigitalnoExigible,
      esDocumentoDigitalnoExigible,
      numIdentificacionPropietario,
      documentoSolicitud.idTipoDocumento,
      tipoIdentificacionPropietario
    );
    document.idForm = documentoSolicitud.idForm;

    if (documentoEncontradoPorId) {
      document.name = documentoEncontradoPorId.nombre;
      document.description = documentoSolicitud.label;
      document.documentoPropietario =
        documentoEncontradoPorId.documentoPropietario;
    }

    this.contentDocuments.push(document);

    return document;
  }
}
